import PropTypes from 'prop-types';
import React from 'react';
import { CircleFilled, PauseFilled } from '@fluentui/react-icons';
import { useStatusStyles } from '../styles';

export const StatusIcon = ({ status }) => {
  const styles = useStatusStyles();

  if (!status) return null;

  if (status === 'Active') {
    return <span className={styles.activeStatus}><CircleFilled /></span>;
  }
  return <span className={styles.pausedStatus}><PauseFilled /></span>;
};

StatusIcon.propTypes = {
  status: PropTypes.string,
};

StatusIcon.defaultProps = {
  status: undefined,
};
